export const JOB_STAT_CARD_DATA_ID_CONTRACT = {
  base: 'job-stat-card',
  container: '',
  statNameContainer: 'stat-name-container',
  icon: 'icon',
  children: 'children'
};
